import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CommaSeparatorService {

  /** JavaScript Number only safely represents integers up to 16 digits. */
  readonly MAX_SAFE_INTEGER_DIGITS = 14;

  constructor() {
  }

  limitDigitLength(value: any, maxIntegerDigits: number = this.MAX_SAFE_INTEGER_DIGITS): string {
    if (value === null || value === undefined) {
      return '';
    }

    let str = String(value).replace(/,/g, '');
    if (str === '' || str === '-') {
      return str;
    }

    let sign = '';
    if (str.startsWith('-')) {
      sign = '-';
      str = str.slice(1);
    }

    const dotIndex = str.indexOf('.');
    let integerPart = dotIndex >= 0 ? str.slice(0, dotIndex) : str;
    const decimalPart = dotIndex >= 0 ? str.slice(dotIndex) : '';

    integerPart = integerPart.replace(/\D/g, '');
    if (integerPart.length > maxIntegerDigits) {
      integerPart = integerPart.slice(0, maxIntegerDigits);
    }

    return sign + integerPart + decimalPart;
  }

  getIntegerDigitCount(value: any): number {
    const normalized = this.limitDigitLength(value);
    const withoutSign = normalized.replace(/^-/, '');
    return withoutSign.split('.')[0].replace(/\D/g, '').length;
  }

  canAcceptMoreDigits(value: any, maxIntegerDigits: number = this.MAX_SAFE_INTEGER_DIGITS): boolean {
    return this.getIntegerDigitCount(value) < maxIntegerDigits;
  }

  extractComma(userInput: any) {
    return userInput ? this.limitDigitLength(String(userInput).replace(/,/g, '')) : '';
  }

  removeComma(userInput: any, dpoint: any) {
    let count: any;
    var amountInString = '';
    if (userInput === null || userInput === undefined || userInput === '') {
      return '';
    } else {
      userInput = String(userInput);
      amountInString = '';
      for (var i = 0; i < userInput.length; i++) {
        var char = userInput.charAt(i);
        var charForCheck = char;
        char = char.match(/\d+/g);
        if (char != null) {
          amountInString = amountInString + userInput.charAt(i);
          count = 1;
        } else if (charForCheck == ',') {
          continue;
        } else if (charForCheck == '-') {
          amountInString = amountInString + userInput.charAt(i);
        } else if (charForCheck == '.') {
          amountInString = amountInString + userInput.charAt(i);
        }
      }
    }
    amountInString = this.limitDigitLength(amountInString);
    if (amountInString === '' || amountInString === '-') {
      return '';
    }
    var ntoFixed = 6;
    if (dpoint != undefined && dpoint != null) {
      ntoFixed = parseInt(dpoint);
    }
    const parsed = parseFloat(amountInString);
    return isNaN(parsed) ? '' : parsed.toFixed(ntoFixed);
  }

  removeCommaNegAllow(userInput: any, dpoint: any) {
    let count: any;
    var amountInString = '';

    if (userInput === null || userInput === undefined || userInput === '') {
      return '';
    } else {
      userInput = String(userInput);
      amountInString = '';
      let hasMinusSign = false;

      for (var i = 0; i < userInput.length; i++) {
        var char = userInput.charAt(i);
        var charForCheck = char;
        char = char.match(/\d+/g);

        if (char != null) {
          amountInString = amountInString + userInput.charAt(i);
          count = 1;
        } else if (charForCheck == ',') {
          continue;
        } else if (charForCheck == '-' && !hasMinusSign && i === 0) {
          // Only allow minus sign at the beginning and only once
          amountInString = amountInString + userInput.charAt(i);
          hasMinusSign = true;
        } else if (charForCheck == '.') {
          amountInString = amountInString + userInput.charAt(i);
        }
      }
    }

    var ntoFixed = 6;
    if (dpoint != undefined && dpoint != null) {
      ntoFixed = parseInt(dpoint);
    }

    // Allow "-" to remain while user is typing
    if (amountInString === '-') {
      return '-';
    }

    // Only process if we have a valid number (not just "-")
    if (amountInString && amountInString !== '-') {
      amountInString = this.limitDigitLength(amountInString);
      const parsed = parseFloat(amountInString);
      return isNaN(parsed) ? '' : parsed.toFixed(ntoFixed);
    }

    return amountInString;
  }

  removeCommaExpenditure(userInput: any, dpoint: any) {
    let count: any;
    var amountInString = '';
    if (userInput === null || userInput === undefined || userInput === '') {
      return '';
    } else {
      amountInString = '';
      for (var i = 0; i < userInput.length; i++) {
        var char = userInput.charAt(i);
        var charForCheck = char;
        char = char.match(/\d+/g);
        if (char != null) {
          amountInString = amountInString + userInput.charAt(i);
          count = 1;
        } else if (charForCheck == ',') {
          continue;
        } else if (charForCheck == '-') {
          amountInString = amountInString + userInput.charAt(i);
        } else if (charForCheck == '.') {
          amountInString = amountInString + userInput.charAt(i);
        }
      }
    }
    amountInString = this.limitDigitLength(amountInString);
    var ntoFixed = 6;
    if (dpoint != undefined && dpoint != null) {
      ntoFixed = parseInt(dpoint);
    }
    return parseFloat(amountInString).toFixed(ntoFixed);
  }


  // converting any number to BDT Currency Seperator
  // Example : 123445789 => 12,34,45,789
  currencySeparatorBD(nStr: any) {
    if (nStr === '0') {
      return '0';
    } else if (nStr === '-') {
      return '-';
    } else if (nStr == null || nStr === '' || isNaN(nStr)) {
      return '';
    } else {
      const cleanValue = this.limitDigitLength(String(nStr).replace(/,/g, ''));
      return new Intl.NumberFormat('en-IN').format(parseFloat(cleanValue));
    }
  }

  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  commaSeparator(value: any): string {
    let valueStr: string = this.limitDigitLength(this.commaRemover(value.toString()));
    let length = valueStr.length;
    let finalStr: string = '';

    if (valueStr[0] == '0' && length > 1) {
      return '';
    }

    if (length > 3) {

      finalStr = ',' + (valueStr[length - 3] + valueStr[length - 2] + valueStr[length - 1]) + finalStr;
      length -= 3;

      while (length > 2) {

        finalStr = ',' + (valueStr[length - 2] + valueStr[length - 1]) + finalStr;
        length -= 2;

      }

      length--;

      while (length >= 0) {

        finalStr = valueStr[length] + finalStr;
        length -= 1;

      }


      return finalStr;

    } else {
      return valueStr;
    }

  }

  commaRemover(value: string): string {
    return value.replace(/,/g, '');
  }

  currencySeparatorBDWithExtract(str) {
    const nStr = str.replace(/,/g, '');

    if (nStr === '0' || nStr === '-') {
      return nStr;
    } else if (nStr == null || nStr === '' || isNaN(nStr)) {
      return '';
    } else {
      const cleanValue = this.limitDigitLength(nStr);
      return new Intl.NumberFormat('en-IN').format(parseFloat(cleanValue));
    }
  }

}
